{
  "forms": {
    "confirmation": {
      "thank_you": "Merci",
      "default_message": "Merci d'avoir soumis le formulaire. Vos informations ont été reçues avec succès.",
      "redirect_message": "Vous êtes redirigé vers",
      "nexl_branding": "Ce formulaire a été créé avec Nexl. Explorez",
      "learn_more": "pour en savoir plus"
    }
  }
}
